import { render } from "./Carriers.vue?vue&type=template&id=321e4473&scoped=true&ts=true"
import script from "./Carriers.vue?vue&type=script&lang=ts"
export * from "./Carriers.vue?vue&type=script&lang=ts"

import "./Carriers.vue?vue&type=style&index=0&id=321e4473&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321e4473"]])

export default __exports__